import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Box, Divider, Grid, TextField, Typography } from '@mui/material';

type Props = {
    disabled?: boolean;
};

const Form = ({disabled = false}: Props) => {
    const {register, formState: {errors}} = useFormContext<any>();

    return (
        <Box sx={{p: '1rem 1.5rem'}}>
            <Box>
                <Typography variant="h5">Informations</Typography>
                <Grid container spacing={2} columns={{xs: 1, sm: 3}}>
                    <Grid item xs={1}>
                        <TextField
                            id='name'
                            label="Nom de l'agence"
                            {...register('name')}
                            autoComplete='off'
                            disabled={disabled}
                            error={errors?.name ? true : false}
                            helperText={errors?.name ? errors.name.message as string : null}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <TextField
                            id='address'
                            label='Adresse postale'
                            {...register('address.address')}
                            autoComplete='off'
                            disabled={disabled}
                            error={errors?.address && (errors.address as any).address ? true : false}
                            helperText={errors?.address && (errors.address as any).address ? (errors.address as any).address.message : null}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Divider sx={{my: '1rem'}} />
            <Box sx={{ mt: '1rem' }}>
                <Typography variant="h5">Intégrations</Typography>
                <Grid container spacing={2} columns={{xs: 1, sm: 3}}>
                    <Grid item xs={1}>
                        <TextField
                            id='code'
                            label='Code Agence (Anael)'
                            {...register('code')}
                            autoComplete='off'
                            disabled={disabled}
                            error={errors?.code ? true : false}
                            helperText={errors?.code ? errors.code.message as string : null}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <TextField
                            id='talent_plug_uuid'
                            label='UID Talent Plug'
                            {...register('talent_plug_uuid')}
                            autoComplete='off'
                            disabled={disabled}
                            error={errors?.talent_plug_uuid ? true : false}
                            helperText={errors?.talent_plug_uuid ? errors.talent_plug_uuid.message as string : null}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Divider sx={{my: '1rem'}} />
            <Box sx={{ mt: '1rem' }}>
                <Typography variant="h5">Social</Typography>
                <Grid container spacing={2} columns={{xs: 1, sm: 3}}>
                    <Grid item xs={1}>
                        <TextField
                            id='email'
                            label='Adresse e-mail'
                            {...register('email')}
                            autoComplete='off'
                            disabled={disabled}
                            error={errors?.email ? true : false}
                            helperText={errors?.email ? errors.email.message as string : null}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <TextField
                            id='phone_number'
                            label='Numéro de téléphone'
                            {...register('phone_number')}
                            autoComplete='off'
                            disabled={disabled}
                            error={errors?.phone_number ? true : false}
                            helperText={errors?.phone_number ? errors.phone_number.message as string : null}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <TextField
                            id='social_link'
                            label='Lien vers un reseau social'
                            {...register('social_link')}
                            autoComplete='off'
                            disabled={disabled}
                            error={errors?.social_link ? true : false}
                            helperText={errors?.social_link ? errors.social_link.message as string : null}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export { Form };